<ng-container *ngIf="parentFormGroup">
    <app-multiple-select-filter-simple (focussedEvent)="focussed()"
                                       [parentFormGroup]="parentFormGroup"
                                       [parentFormControlName]="jsonControlName"
                                       [elements]="elements"
                                       *ngIf="!formValue.fieldDefinition.data || formValue.fieldDefinition.data.indexOf('buttons') === -1" (click)="setMeasured(true)">
    </app-multiple-select-filter-simple>
    <app-chips [items]="chipItems" (selectedChangedEvent)="chipItemsSelectionChanged()"
               (focussedEvent)="setMeasured(true)"
               [disabled]="!measured"
               *ngIf="formValue.fieldDefinition.data && formValue.fieldDefinition.data.indexOf('buttons') > -1">
    </app-chips>
</ng-container>

